module.exports = __webpack_public_path__ + "img/130.2.9a5c9c6d.png";